import * as React from "react";
import { Button, FormControl, Grid, InputLabel, MenuItem, Select } from "@material-ui/core";

import { ColorPalette } from "./ColorPalette";

import { RandomHelper } from "../Utility/RandomHelper";

import { IColorPalette } from "../Model/IColorPalette";
import { IColorPaletteReference } from "../Model/IColorPaletteReference";

const PaletteColorCount = 5;

interface IProps {
    readonly label: string;
    readonly palettes: IColorPalette[];
    readonly selectedRef: IColorPaletteReference | undefined;

    readonly onSelectionChanged: (ref?: IColorPaletteReference) => void;
}

export function ColorPaletteSelector(props: IProps): React.ReactElement {
    const onShuffleClicked = () => {
        if (props.selectedRef === undefined) {
            return;
        }
        
        const shuffle = (props.selectedRef.shuffle + 1) % PaletteColorCount;

        props.onSelectionChanged({
            ...props.selectedRef,
            shuffle
        });
    }

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const paletteIndex = event.target.value as number;

        if (paletteIndex >= props.palettes.length) {
            props.onSelectionChanged(undefined);
            return;
        }

        const ref: IColorPaletteReference = {
            index: paletteIndex,
            shuffle: Math.abs(RandomHelper.randomInt32()) % PaletteColorCount
        };

        props.onSelectionChanged(ref);
    };

    const elements: React.ReactElement[] = [];
    const paletteCount = props.palettes.length;

    elements.push(<MenuItem value={paletteCount} key={paletteCount}><ColorPalette /></MenuItem>);

    props.palettes.forEach((p, key) => {
        elements.push(<MenuItem value={key} key={key}><ColorPalette colors={p.colors} /></MenuItem>);
    });

    return (
        <Grid container spacing={1} direction="row" alignItems="center">
            <Grid item>
                <FormControl fullWidth>
                    <InputLabel id="selector-label">{props.label}</InputLabel>
                    <Select
                        autoWidth
                        labelId="selector-label"
                        value={props.selectedRef?.index ?? paletteCount}
                        onChange={handleChange}
                    >
                        {elements}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item>
                <Button color="primary" onClick={onShuffleClicked}>🎲</Button>
            </Grid>
        </Grid>
    );
}